import * as angular from "angular";

export class BringozUtils {
  constructor() {
  }

  inherit(ChildClass, ParentClass, methods) {
    let childMethods = ChildClass.prototype;
    ChildClass.prototype = Object.create(ParentClass.prototype);
    ChildClass.prototype.constructor = ChildClass; // restoring proper constructor for child class
    angular.forEach(Object.keys(childMethods), (k) => {
      ChildClass.prototype[k] = childMethods[k];
    });
    if (angular.isObject(methods)) {
      angular.extend(ChildClass.prototype, methods);
    }
    return ChildClass;
  }


}

angular
  .module('bringoz.admin.commons')
  .service('$bringozUtils', BringozUtils);
